export const appActionPresentationSingleItem = {
  key: 'presentationSingleItem',
  type: 'app',
  label: 'Returns Single Item',
  description: 'Enabling this will display a single item in the UI.',
  path: 'actions[id:{{actionId}}].presentation.returnsSingleItem',
  shouldRun: ({ changes }) => {
    const paths = ['presentation.returnsSingleItem', 'meta.lastRunOn'];
    return changes?.some((change) => paths.some((path) => change?.path?.includes(path)));
  },
  context: ['appActionOutput'],
  mapContext: ({ app, action, appActionOutput }) => ({
    appName: app?.name,
    name: action?.name,
    currentValue: action?.presentation?.returnsSingleItem,
    actionDetails: {
      model: action?.model,
      operation: action?.operation || 'none',
      slug: action?.slug,
      name: action?.name,
      method: action?.api?.method
    },
    appActionOutput
  }),
  formatLabel: (value) => (value ? 'Yes' : 'No'),
  prompt: 'appActionPresentationSingleItem'
};
